import { render, staticRenderFns } from "./ConferenceHome.vue?vue&type=template&id=80bd258e&scoped=true&"
import script from "./ConferenceHome.vue?vue&type=script&lang=js&"
export * from "./ConferenceHome.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceHome.vue?vue&type=style&index=0&id=80bd258e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bd258e",
  null
  
)

export default component.exports